import * as React from "react";
import { CSSTransition } from "react-transition-group";
import Login from "./sign-in/Login";
import AskResetPassword from "./sign-in/AskResetPassword";
import ChooseNewPassword from "./sign-in/ChooseNewPassword";
import PasswordResetSent from "./sign-in/PasswordResetSent";
import Csrf from "./commons/model/Csrf";
import { createRoot } from "react-dom/client";

export interface SignInProps {
  thisRegionLabel: string;
  isMultiRegions: boolean;
  loginErrorMessages?: string;
  loginUsernameError: boolean;
  loginPasswordError: boolean;
  resetPasswordToken?: string;
  contactUsEmail: string;
  csrf: Csrf;
  passwordReset: boolean;
}

interface SignInState {
  status: SignInStatus;
  showPasswordUpdateMsg: boolean;
}

enum SignInStatus {
  LOGIN = "LOGIN",
  ASK_PASSWORD_RESET = "ASK_PASSWORD_RESET",
  PASSWORD_RESET_MAIL_SENT = "PASSWORD_RESET_MAIL_SENT",
  CHOOSE_NEW_PASSWORD = "CHOOSE_NEW_PASSWORD",
}

export default class SignIn extends React.Component<SignInProps, SignInState> {
  constructor(props: SignInProps) {
    super(props);

    let firstPane = SignInStatus.LOGIN;
    if (this.props.resetPasswordToken != null) {
      firstPane = SignInStatus.CHOOSE_NEW_PASSWORD;
    }
    this.state = {
      status: firstPane,
      showPasswordUpdateMsg: this.props.passwordReset,
    };
  }

  render() {
    const login = (
      <Login
        {...this.props}
        showResetPasswordSuccessPanel={this.state.showPasswordUpdateMsg}
        errorMessages={
          this.props.loginErrorMessages ? this.props.loginErrorMessages.split(",") : []
        }
        onPasswordReset={() => this.setState({ status: SignInStatus.ASK_PASSWORD_RESET })}
        csrf={this.props.csrf}
      />
    );

    const askResetPassword = (
      <AskResetPassword
        onPasswordResetAsked={() =>
          this.setState({ status: SignInStatus.PASSWORD_RESET_MAIL_SENT })
        }
      />
    );

    const passwordResetSent = (
      <PasswordResetSent
        contactUsEmail={this.props.contactUsEmail}
        onBackToLogin={() => this.setState({ status: SignInStatus.LOGIN })}
      />
    );

    const chooseNewPassword = (
      <ChooseNewPassword
        resetPasswordToken={this.props.resetPasswordToken}
        onPasswordChanged={() => {
          const redirectUrl = new URLSearchParams(document.location.search).get("redirect-url");
          if (redirectUrl) {
            document.location.assign(redirectUrl);
          } else {
            this.setState({
              status: SignInStatus.LOGIN,
              showPasswordUpdateMsg: true,
            });
          }
        }}
      />
    );

    const componentByStatus = {
      LOGIN: login,
      ASK_PASSWORD_RESET: askResetPassword,
      PASSWORD_RESET_MAIL_SENT: passwordResetSent,
      CHOOSE_NEW_PASSWORD: chooseNewPassword,
    };

    return (
      <>
        {Object.keys(SignInStatus).map((status) => (
          <CSSTransition
            classNames="todo" // LongTermFix jladron 07/02/2019: enable a nice css transformation if needed
            timeout={0}
            key={status}
            in={status === this.state.status}
            mountOnEnter={true}
            unmountOnExit={true}
          >
            {componentByStatus[status]}
          </CSSTransition>
        ))}
      </>
    );
  }

  static loadComponent(elementId: string, props: SignInProps) {
    const container = document.getElementById(elementId);
    const root = createRoot(container!);
    root.render(<SignIn {...props} />);
  }
}
